export const RegionSelector = {
  PoliticaElectoral: 0,
  Territorial: 1,
  Georeferencia: 2,
} as const;

export type RegionSelector = (typeof RegionSelector)[keyof typeof RegionSelector];

export const RegionSelectorLabels = {
  [RegionSelector.PoliticaElectoral]: 'Política Electoral',
  [RegionSelector.Territorial]: 'Territorial',
  [RegionSelector.Georeferencia]: 'Georeferencia',
};

export interface Region {
  id: string;
  countryIds: string[];
  countryNames?: string[];
  name: string;
  selector: RegionSelector;
  selectorLabel?: string;
  parentId: string | null;
  parentName?: string;
  isActive: boolean;
  createdAt?: string;
}

export interface RegionChild {
  id: string;
  name: string;
  selector: RegionSelector;
  isActive: boolean;
}

export interface RegionDetail extends Region {
  createdAt: string;
  updatedAt: string;
  createdBy: string;
  children: RegionChild[];
}

export interface CreateRegionRequest {
  countryIds: string[];
  name: string;
  selector: RegionSelector;
  parentId?: string | null;
}

export interface UpdateRegionRequest {
  name?: string;
  selector?: RegionSelector;
  countryIds?: string[];
  parentId?: string | null;
}

export interface RegionPaginationParams {
  page?: number;
  pageSize?: number;
  searchTerm?: string;
  isActive?: boolean;
  countryIds?: string[];
  selector?: RegionSelector;
  parentId?: string;
  getAllLevels?: boolean;
  /** Deja que el servidor amplie countryIds con ancestros y descendientes del arbol territorial. */
  expandCountryHierarchy?: boolean;
}

export interface Paginated<T> {
  items: T[];
  page: number;
  pageSize: number;
  totalCount: number;
  totalPages: number;
  hasPreviousPage: boolean;
  hasNextPage: boolean;
  firstItemOnPage: number;
  lastItemOnPage: number;
}
